module.exports = __webpack_public_path__ + "static/img/microphone-control-close.0bf7f9ed.svg";